import { createApp } from 'vue'
import './assets/index.css'
import App from './App.vue'

// Lazy load non-critical dependencies
const initializeApp = async () => {
  const [
    { default: router },
    { default: i18n },
    { pinia },
    { FontLoader },
    { geographicalApi }
  ] = await Promise.all([
    import('./router'),
    import('@/i18n'),
    import('@/stores'),
    import('@/plugins/fontLoader'),
    import('@/services/geographical_api')
  ])

  const app = createApp(App);

  // Register plugins in optimal order
  app.use(pinia);
  app.use(i18n);
  app.use(router);
  app.use(FontLoader);

  // Start preloading geographical data in background (don't wait for it)
  geographicalApi.preloadData().catch(console.warn);

  // Remove loading spinner and mount app
  const loadingElement = document.querySelector('.loading-spinner');
  if (loadingElement) {
    loadingElement.remove();
  }

  app.mount('#app');
}

// Initialize app
initializeApp().catch(console.error);
